export const enum MissionButtonState {
  Disabled = "DISABLED",
  Enabled = "ENABLED",
  Complete = "COMPLETE",
  CompleteWithReview = "COMPLETE_WITH_REVIEW",
}
